import React from "react";
import {connect} from "react-redux";
import {Image, ImageBackground} from "react-native";

export class LogoComplet extends React.Component{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.logoCompletPicto;
    }

    render() {

        return (<Image style={this.props.style} resizeMode={"contain"} source={(!this.props.isDark) ? this.picto.light : this.picto.dark}  />);
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(LogoComplet);


const BOLogoComplet = ({ style }) => {
  return <Image style={style} resizeMode={"contain"} source={{uri: '/app_config/icon'}} />
}

export { BOLogoComplet }

